import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scheduleIndexUserEditFormModal" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "scheduleIndexUserEditFormModalLabel"
}, " 担当者変更 ", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "recipient-name",
  class: "col-form-label"
}, "担当者", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("form", {
  id: "scheduleUserForm",
  method: "POST"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "hidden",
    id: "schedule_id",
    name: "schedule_id"
  }),
  /*#__PURE__*/_createElementVNode("input", {
    type: "hidden",
    id: "schedule_users",
    name: "schedule_users"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_bs_modal = _resolveComponent("bs-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_bs_modal, {
        ref: "scheduleUserEditModalRef",
        "modal-dialog-settings": ['modal-fullscreen']
      }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideScheduleUserEditModal()))
          }, " キャンセル "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateScheduleUser()))
          }, " 登録 ")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_multiselect, {
              "data-bs-backdrop": "static",
              modelValue: _ctx.userEditForm.users,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEditForm.users) = $event)),
              mode: "tags",
              placeholder: "Select your characters",
              options: _ctx.usersForMultiPulldownByVue.users[0],
              searchable: true,
              groups: true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _hoisted_5
  ], 64))
}